import lang from "@/views/modules/Applications/language/en";

let searchFieldsDef = {
    /* 'app_no': {
        label: lang.LBL_APPLICATION_NO,
    }, */
    'application_title': {
        label: lang.LBL_PROJECT_TITLE,
    },
    /*'strategic_priority': {
        label: lang.LBL_PRIORITY,
        type: 'checkbox',
        field_infos: 'strategic_priority',
    },*/
    'opportunity_title': {
        label: lang.LBL_OPP_TITLE,
        relRef: 'applications_opportunitys',
    },
  /*  'opportunity_funder': {
        label: lang.LBL_FUNDER,
        relRef: 'applications_opportunitys',
    },*/
    'opportunity_type': {
        label: lang.LBL_SCHEME_TYPE,
        type: 'checkbox',
        field_infos: 'scheme_type',
        relRef: 'applications_opportunitys',
    },
    /*'country_id': {
        label: lang.LBL_COUNTRY,
        relRef: 'applications_opportunitys',
        type:'selectcomponent',
        route: 'countrylists',
        moduleName: 'CountryLists',
        name: 'op_country_name',
        id: 'op_country_id',
    },*/
    'created_by': {
        label: lang.LBL_OPPORTUNITY_BY,
        relRef: 'applications_opportunitys',
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'op_user_name',
        id: 'op_created_by',
    },
    'created_by__app': {
        label: lang.LBL_APPLICATION_BY,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'app_user_name',
        id: 'app_created_by',
    },
    'date_entered': {
        label: lang.LBL_APPLICATION_DATE,
        type: 'daterange',
    },
    'status': {
        label: lang.LBL_STAGE,
        type: 'checkbox',
        field_infos: 'application_stages_filter',
    },
};
export default { searchFieldsDef }